export default function AboutSection() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://advancedbenefitdesigns.com/wp-content/uploads/2025/02/KMS-Pro-Shot_page-0001-e1741151877241.jpg"
                alt="Kevin Smith - Advanced Benefit Designs"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900/90 to-transparent p-8">
                <h3 className="text-3xl font-bold text-white mb-1">Kevin Smith</h3>
                <p className="text-teal-400 font-semibold">Founder & Principal Advisor</p>
              </div>
            </div>
            
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-teal-500/10 rounded-2xl -z-10"></div>
          </div>

          {/* Content Side */}
          <div className="space-y-6">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                About <span className="text-teal-600">Advanced Benefit Designs</span>
              </h2>
              <div className="w-20 h-1 bg-teal-500 rounded-full mb-6"></div>
            </div>

            <p className="text-lg text-slate-700 leading-relaxed">
              At Advanced Benefit Designs, we bring over <strong>25 years of expertise</strong> in the insurance industry, specializing in health and group benefit programs.
            </p>

            <p className="text-slate-600 leading-relaxed">
              Founded in 1999 in Doylestown, PA, our company was built on a foundation of industry knowledge, dedication, and a passion for helping businesses thrive. We empower small businesses, individuals, and families with strategic financial planning to achieve their goals while minimizing risk.
            </p>

            <p className="text-slate-600 leading-relaxed">
              Our expert-driven solutions help optimize wealth management, reduce financial uncertainty, and explore tax-saving strategies to maximize your financial potential.
            </p>

            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
                <div className="text-3xl font-bold text-teal-600 mb-2">1999</div>
                <div className="text-slate-600 text-sm font-medium">Established</div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
                <div className="text-3xl font-bold text-teal-600 mb-2">500+</div>
                <div className="text-slate-600 text-sm font-medium">Happy Clients</div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <a
                href="#contact"
                className="px-8 py-3 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
              >
                Get Started Today
              </a>
              <a
                href="https://community.advancedbenefitsdesigns.com/login"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3 bg-white text-slate-900 rounded-lg font-semibold hover:bg-slate-100 transition-all duration-300 border border-slate-300 whitespace-nowrap cursor-pointer"
              >
                Join Our Community
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
